// This file configures the Supabase client for the application.
// Credentials are loaded from environment variables for security.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

// Supabase project credentials (publishable keys - safe to include in client code)
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || "https://vdvkrxwohdtgxheehlki.supabase.co";
const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY || "";

export { SUPABASE_URL, SUPABASE_ANON_KEY };

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});